import { useCallback } from 'react';
import { analyticsService } from '../services/analytics';
import { ANALYTICS_EVENTS } from '../config/analytics';

export const useAnalytics = () => {
  const trackEvent = useCallback((eventName, eventCategory, properties = {}) => {
    analyticsService.trackEvent(eventName, eventCategory, properties);
  }, []);

  return {
    trackEvent,
    events: ANALYTICS_EVENTS
  };
}; 